export const Method = {
    Manual: "manual",
    Auto: "auto"
};

export const SelectMode = {
    Rectangle: "rect",
    Circle: "circle",
    UserDefined: "user"
};

export const EdgeDetection = {
    None: "none",  //  no algorithm is applied to select outside points
    BoxSelection: "box-selection", // applies a box selection algorithm for extracting outside points
    CircleSelection: "circle-selection" // applies a circle selection algorithm for extracting outside points
};



// WEBPACK FOOTER //
// ./src/components/AreaCalculatorDialog/Constants.js